window.fisherAnalytics = window.fisherAnalytics || {};
/*
    * DOM Observer Module
    * This module sets up a MutationObserver to watch for changes in the DOM.
    * It uses an IIFE to encapsulate its scope and avoid polluting the global namespace.
    * This is designed to handle elements that are dynamically added to the DOM after the initial page load.
    * If you only need to handle elements that already exist in the DOM at page load, consider using a simpler approach as shown in dom-listener.js.
 */
window.fisherAnalytics.domObserver = (function() {
    // All constants, variables, and functions are now scoped inside this IIFE
    let debounceTimeout;
    const selectorsToWatch = ['li.signOut','.js-checkout-button','.checkout_button','[data-pa-element="downloadPdfButton"]','#complete-request-ok-button'];
    const selectorsConfig = {
        'li.signOut': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'logout',
            eventType: 'click',
            listenerCallback: dispatchEvent
        },
        '.js-checkout-button': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'proceedCheckout',
            eventType: 'click',
            listenerCallback: dispatchEvent
        },
        '[data-pa-element="downloadPdfButton"]': {
            description: 'Download PDF button on Quote Confirmation page',
            method: [window.fisherAnalytics.utils.addEvents],
            useParent: true,
            parentSelector: 'button',
            eventName : 'fileDownload',
            eventType: 'click',
            urlPattern: ['store1/quotes/'],
            listenerCallback: window.fisherAnalytics.quotes.triggerDownloadEventButton
        },
        '#complete-request-ok-button': {
            description: 'Download PDF button on Request Instant Quote Confirmation modal',
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'fileDownloadInstantQuote',
            eventType: 'click',
            callBackArgs: sessionStorage.getItem('quoteNumber'),
            listenerCallback: [window.fisherAnalytics.quotes.triggerDownloadEvent,(function(){ sessionStorage.removeItem('quoteNumber'); })]
        }
    }

    function debounceInit() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            window.fisherAnalytics.utils.initModules(selectorsToWatch, selectorsConfig);
        }, 100); // Adjust the delay as needed
    }
    function dispatchEvent(e){
        var element = e.currentTarget;
        var eventName = element.dataset.eventName;
        document.dispatchEvent(new CustomEvent(eventName));
    }
    // Expose only what you want public
    return {
        debounceInit,
        dispatchEvent,
        selectorsToWatch,
        selectorsConfig
    };
})();

// Set up a MutationObserver to call debounceInit() whenever the DOM changes
const domObserver = new MutationObserver((mutationsList, observer) => {
    window.fisherAnalytics.domObserver.debounceInit();
});

// Define the target node and domObserver options
const domObserverTargetNode = document.body;
const domObserverOptions = {
    childList: true, // Observe direct children
    subtree: true,   // Observe all descendants
    attributes: false, // Do not observe attribute changes
    characterData: false // Do not observe character data changes
};

// Start observing the target node for configured mutations
domObserver.observe(domObserverTargetNode, domObserverOptions);
// Initial call to init() to handle any elements already present in the DOM
window.fisherAnalytics.utils.initModules(window.fisherAnalytics.domObserver.selectorsToWatch, window.fisherAnalytics.domObserver.selectorsConfig);
